import React, { useEffect, useState } from 'react';
import Container from '../../atoms/Container';
import Styles from './Menu.css';

function MenuCar10({ importPrefix }) {
  const [open, setOpen] = useState(null);
  const [enableDismiss, setEnableDismiss] = useState(false);

  const getDialogClass = (index) => {
    const state = open === index ? 'opened' : 'closed';
    return `menu-content ${state}`;
  };

  const updateOpenState = (index) => {
    if (index === open) setOpen(null);
    else setOpen(index);
  };

  useEffect(() => {
    const val = parseInt(open, 10);
    setEnableDismiss(!isNaN(val));
  }, [open]);

  const MenuContent = (
    <nav>
      <Container type="ul">
        <li>
          <a href="#rastreadores-o-que-e" id="">
            O que é?
          </a>
        </li>
        <li>
          <a href="#rastreadores-parcerias" id="">
            Parceira
          </a>
        </li>
        {/* <li>
          <a href="#rastreadores-como-contratar" id="">
            Como contratar
          </a>
        </li> */}
        <li>
          <a href="#rastreadores-formulario" id="">
            Formulário
          </a>
        </li>
        <li>
          <a href="#rastreadores-parcerias" id="">
            Contatos
          </a>
        </li>
      </Container>
    </nav>
  );

  return (
    <>
      {enableDismiss && (
        <div
          className="dismiss-menu"
          onClick={(ev) => {
            ev.preventDefault();
            setOpen(null);
          }}
        />
      )}
      <section id="santander-menu">
        <div className="mega-menu-ampless">{MenuContent}</div>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

MenuCar10.defaultProps = {
  importPrefix: '',
};

export default MenuCar10;
